// import {
//   userIsAuthenticatedRedir,
//   userIsNotAuthenticatedRedir,
// } from '../util/auth';
import Home from '../page/home';
// import Login from '../page/login';
// import ResetPwd from '../page/resetPwd';
// import CreateNewAccount from '../page/createNewAccount';
import Index from '../page/index';
import Account from '../page/account';
import Device from '../page/device';
import Page404 from '../page/404';
import Use from '../page/use';
import Rule from '../page/rule';
import UseUs from '../page/useUs';
import RuleUs from '../page/ruleUs';
import Logout from '../page/logout';
import {
  PATH_WEB_404,
  PATH_WEB_ACCOUNT,
  // PATH_WEB_CREATE_NEW_ACCOUNT,
  PATH_WEB_DEVICE,
  PATH_WEB_HOME,
  PATH_WEB_INDEX,
  // PATH_WEB_LOGIN,
  // PATH_WEB_RESET_PASSWORD,
  PATH_WEB_USE,
  PATH_WEB_RULE,
  PATH_WEB_USEUS,
  PATH_WEB_RULEUS,
  PATH_WEB_LOGOUT,
} from './server';

// const LoginAPP = userIsNotAuthenticatedRedir(PATH_WEB_HOME)(Login);
// const HomeAPP = userIsAuthenticatedRedir(PATH_WEB_INDEX)(Home);

export const routes = [
  {
    path: PATH_WEB_INDEX,
    component: Index,
    routes: [
      {
        exact: true,
        path: PATH_WEB_INDEX,
        redirect: PATH_WEB_HOME,
      },
      // {
      //   path: PATH_WEB_LOGIN,
      //   component: Login,
      // },
      // {
      //   path: PATH_WEB_CREATE_NEW_ACCOUNT,
      //   component: CreateNewAccount,
      // },
      // {
      //   path: PATH_WEB_RESET_PASSWORD,
      //   component: ResetPwd,
      // },
      {
        path: PATH_WEB_HOME,
        component: Home,
        routes: [
          {
            exact: true,
            path: PATH_WEB_HOME,
            redirect: PATH_WEB_DEVICE,
          },
          {
            path: PATH_WEB_ACCOUNT,
            component: Account,
          },
          {
            path: PATH_WEB_DEVICE,
            component: Device,
          },
        ],
      },
      {
        path: PATH_WEB_404,
        component: Page404,
      },
      {
        path: PATH_WEB_USE,
        component: Use,
      },
      {
        path: PATH_WEB_RULE,
        component: Rule,
      },
      {
        path: PATH_WEB_USEUS,
        component: UseUs,
      },
      {
        path: PATH_WEB_RULEUS,
        component: RuleUs,
      },
      {
        path: PATH_WEB_LOGOUT,
        component: Logout,
      },
      {
        path: '*',
        redirect: PATH_WEB_404,
      },
    ],
  },
  {
    path: '*',
    redirect: PATH_WEB_INDEX,
  },
];
